import React from 'react';
import { useLoaderData } from 'react-router-dom';

const PostDetail = () => {

    const details = useLoaderData();
    
    return (
        <div>
            <h1>post detail page</h1>
            <h3>{details.title}</h3>
            <p>{details.body}</p>
        </div>
    );
};

export default PostDetail;